<template>
  <div>
    <Loader v-if="loaderEnabled" v-bind:logo="loaderLogo"></Loader>
    <KTCodePreview v-bind:title="'Danh sách nhân sự'">
      <template v-slot:toolbar>
        <div class="row" v-if="checkPermission('EMPLOYEE_INSERT')">
          <b-dropdown size="sm" id="dropdown-right" right variant="primary">
            <template slot="button-content">
              <i style="font-size: 1rem" class="flaticon2-add-1"></i>
              <span class="font-weight-bolder">Tạo mới nhân sự</span>
            </template>
            <b-dropdown-item>
              <router-link to="/employees/upsert-employee">
                <span style="color: #3f4254; width: 100%">
                  <i style="font-size: 1rem" class="flaticon2-add-1"></i>
                  &nbsp; Tạo nhân sự
                </span>
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item v-if="checkPermission('EMPLOYEE_INSERT')">
              <router-link to="/employees/import-excel-employee">
                <span style="color: #3f4254; width: 100%">
                  <i style="font-size: 1rem" class="la la-file-excel-o"></i>
                  &nbsp; Nhập từ file excel
                </span>
              </router-link>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>
      <template v-slot:preview>
        <!-- Header session -->
        <div class="col-md-12 mb-5">
          <b-row>
            <b-col md="3" class="pl-0">
              <b-input
                size="sm"
                placeholder="Nhập tên nhân sự"
                v-model="search"
                append-icon="search"
                single-line
                hide-details
                v-on:keyup.enter="onFilter()"
              ></b-input>
            </b-col>
              <b-col md="3" class="pl-0">
              <b-input
                size="sm"
                placeholder="Nhập mã nhân sự"
                v-model="searchCode"
                append-icon="search"
                single-line
                hide-details
                v-on:keyup.enter="onFilter()"
              ></b-input>
            </b-col>
            <b-col md="3">
              <vue-autosuggest
                v-model="searchStock"
                :suggestions="filteredOptions"
                @selected="onSelected"
                :limit="10"
                @input="filterStores"
                :input-props="{
                  id: 'autosuggest__input',
                  placeholder: 'Nhập tên cửa hàng',
                }"
              >
                <div
                  slot-scope="{ suggestion }"
                  style="display: flex; align-items: center"
                >
                  {{ suggestion.item.suggestionName }}
                </div>
              </vue-autosuggest>
            </b-col>
            <div class="col-md-8" style="padding-right: 0px">
              <div class="d-flex justify-content-end"></div>
            </div>
          </b-row>
          <b-row class="mt-5">
            <b-col md="1" class="pl-0">
              <b-button
                style="fontweight: 600; width: 70px"
                variant="primary"
                size="sm"
                @click="onFilter()"
                >Lọc</b-button
              >
            </b-col>
          </b-row>
        </div>
        <!-- End of Header session -->
        <!-- Table session -->
        <b-table
          :items="listItem"
          :fields="fields"
          sort-by="count"
          bordered
          hover
          :busy="onLoading"
        >
          <template v-slot:table-busy>
            <vcl-table :speed="5" :animate="true" :columns="10"></vcl-table>
          </template>
          <template v-slot:cell(count)="row">
            <div style="text-align: center">
              <span v-text="row.item.count" class="text-right"></span>
            </div>
          </template>
          <template v-slot:cell(code)="row">
            <a v-bind:href="getLinkDoc(row.item)">
              <span>
                {{ row.item.code }}
              </span>
            </a>
          </template>
          <template v-slot:cell(fullName)="row">
            <div class="font-weight-bolder">
              <span v-text="row.item.fullName" class="text-right"></span>
            </div>
          </template>

          <template v-slot:cell(jobTitleName)="row">
            <div>
              <span v-text="row.item.jobTitleName" class="text-right"></span>
            </div>
          </template>

          <template v-slot:cell(email)="row">
            <div>
              <span v-text="row.item.email" class="text-right"></span>
            </div>
          </template>

          <template v-slot:cell(storeName)="row">
            <div>
              <span
                v-text="row.item.storeName"
                class="font-weight-bolder"
              ></span>
              <br />
              <span
                v-if="row.item.listStoreName"
                v-text="row.item.listStoreName"
                style="font-size: 11px"
              ></span>
            </div>
          </template>
          <template v-slot:cell(isActive)="row">
            <i
              v-bind:class="{
                'fas fa-check text-success': row.item.isActive == 1,
                'fas fa-minus-circle text-danger': row.item.isActive != 1,
              }"
            />
          </template>

          <template v-slot:cell(mobile)="row">
            <div style="text-align: center">
              <span v-text="row.item.mobile" class="text-right"></span>
            </div>
          </template>
          <template v-slot:cell(birthDay)="row">
            <div style="text-align: center">
              <span
                v-text="row.item.birthDay"
                class="text-right text-primary mb-0"
              ></span>
            </div>
          </template>
          <template v-slot:cell(actions)="row">
            <div class="d-flex justify-content-center">
              <b-dropdown size="sm" id="dropdown-left" no-caret right>
                <template slot="button-content">
                  <i
                    style="font-size: 1rem; padding-right: 0px"
                    class="flaticon2-settings"
                  ></i>
                </template>
                <b-dropdown-item
                  @click="editItem(row.item)"
                  v-if="!checkViewOnly()"
                >
                  <span style="color: #3f4254; font-size: 12px">
                    <i style="font-size: 1rem" class="flaticon2-pen"></i>
                    &nbsp; Chỉnh sửa
                  </span>
                </b-dropdown-item>
                <b-dropdown-item
                  @click="showDeleteAlert(row.item)"
                  v-if="checkPermission('EMPLOYEE_DELETE')"
                >
                  <span style="color: #3f4254; font-size: 12px">
                    <i
                      style="font-size: 1rem; color: #d33"
                      class="flaticon2-rubbish-bin-delete-button"
                    ></i>
                    &nbsp; Xóa
                  </span>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </template>
        </b-table>
        <!-- End of Table session -->

        <!-- Paginate session -->
        <b-row>
          <b-col>
            <p class="mt-3 text-dark" style="font-weight: 500">
              Tổng số:
              {{ formatMoney(totalItems) }}
            </p>
          </b-col>
          <b-col>
            <b-pagination-nav
              class="custom-pagination"
              v-show="totalPages >= 2"
              :link-gen="linkGen"
              :number-of-pages="totalPages"
              use-router
              @change="fetchEmployee"
              align="right"
              first-class="page-item-first btn btn-icon btn-sm mr-1 my-1"
              prev-class="page-item-prev btn btn-icon btn-sm mr-.5 my-1"
              next-class="page-item-next btn btn-icon btn-sm mr-1 my-1 ml-.5"
              last-class="page-item-last btn btn-icon btn-sm my-1 "
              page-class="btn btn-icon btn-sm border-0 mr-.5 my-1"
            >
              <template v-slot:first-text>
                <span>
                  <i class="ki ki-bold-double-arrow-back icon-xs"></i>
                </span>
              </template>

              <template v-slot:prev-text>
                <i class="ki ki-bold-arrow-back icon-xs"></i>
              </template>

              <template v-slot:next-text>
                <i class="ki ki-bold-arrow-next icon-xs"></i>
              </template>

              <template v-slot:last-text>
                <span class="text-info">
                  <i class="ki ki-bold-double-arrow-next icon-xs"></i>
                </span>
              </template>
            </b-pagination-nav>
          </b-col>
        </b-row>
        <!-- End of Paginate session -->
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import Swal from 'sweetalert2';
import ApiService from '@/core/services/api.service';
import { mapGetters } from 'vuex';
import Loader from '@/view/content/Loader.vue';
import decounce from 'debounce';
import { VclTable } from 'vue-content-loading';
import { TIME_TRIGGER } from './../../../utils/constants';
import { VueAutosuggest } from 'vue-autosuggest';
import permissionMixin from '@/view/mixins/permission.mixin';

export default {
  mixins: [permissionMixin],
  data() {
    return {
      onLoading: false,
      btnCreate: {
        fontWeight: '600!important',
      },
      isSearching: false,
      storeName: '',
      currentPage: 0,
      totalPages: 1,
      count: 1,
      totalItems: 0,
      page: 1,
      search: '',
      searchCode: '',
      listItem: [],
      linkGen: (pageNum) => {
        return pageNum === 1 ? '?' : `?page=${pageNum}`;
      },
      fields: [
        {
          key: 'count',
          label: 'STT',
          thStyle: {
            textAlign: 'center',
            fontWeight: 600,
            color: '#181c32',
            width: '5%',
          },
          tdClass: 'sttClass',
        },
        {
          key: 'code',
          label: 'Mã nhân sự',
          sortable: false,
          thStyle: { width: '15%' },
        },
        {
          key: 'fullName',
          label: 'Tên nhân sự',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '25%' },
        },
        {
          key: 'jobTitleName',
          label: 'Chức vụ',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '15%' },
        },
        {
          key: 'storeName',
          label: 'Cửa hàng',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '25%' },
        },
        {
          key: 'isActive',
          label: 'Hoạt động',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          tdClass: 'text-center',
        },
        { key: 'actions', label: '' },
      ],
      options: [
        {
          data: [],
        },
      ],
      filteredOptions: [],
      limit: 10,
      searchStock: '',
    };
  },
  components: {
    KTCodePreview,
    Loader,
    VclTable,
    VueAutosuggest,
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Nhân sự', route: 'employees' },
      { title: 'Danh sách nhân sự' },
    ]);
  },
  created() {
    this.fetchEmployee();
    this.fetchStore();
  },
  methods: {
    editItem: function (item) {
      this.$router.push({
        name: 'upsert-employee',
        query: { id: item.id },
      });
    },
    onFilter() {
      this.isSearching = true;
      this.$route.query.page = 1;
      this.$router.push({
        name: 'list-employee',
      });
      this.fetchEmployee();
    },
    fetchEmployee: async function () {
      this.onLoading = true;
      this.page = this.$route.query.page;

      if (!this.page) {
        this.page = 1;
      }

      if (!this.search) {
        this.search = '';
      }

      if (!this.searchCode) {
        this.searchCode = '';
      }

      if (!this.searchStock) {
        this.selected = null;
      }

      const params = {
        page: this.page,
        pageSize: 10,
        fullName: this.search,
        code: this.searchCode,
        storeId: this.selected,
      };

      ApiService.query('v1/employees', { params }).then((response) => {
        if (this.page === 1) {
          this.count = 1;
        } else {
          this.count = 1 + (this.page - 1) * 10;
        }
        this.count = 1;
        const responseData = response.data.data;
        this.totalPages = responseData.totalPage;
        this.totalItems = responseData.totalRow;
        this.listItem = responseData.dataset.map((item, index) => {
          return {
            ...item,
            count: index + 1,
          };
        });
        this.isSearching = false;
        this.onLoading = false;
      });
    },
    deleteItem: async function (item) {
      ApiService.delete('v1/employees' + '/' + item.id)
        .then((data) => {
          this.makeToastSuccess(data.data.message);
          this.fetchEmployee();
        })
        .catch((error) => {
          console.error('Error deleting employee:', error);
          const errorMessage =
            error.response?.data?.message ||
            error.message ||
            'Lỗi khi xóa nhân viên!';
          this.makeToastFaile(errorMessage);
        });
    },
    showDeleteAlert: function (item) {
      Swal.fire({
        title: 'Xóa nhân viên!',
        text: 'Bạn có chắc muốn xóa nhân viên này không ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Xóa',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
        showClass: {
          popup: 'animate__animated animate__fadeInDown',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
        },
      }).then((result) => {
        if (result.value) {
          this.deleteItem(item);
        }
      });
    },
    checkViewOnly: function () {
      if (this.checkPermission('EMPLOYEE_UPDATE')) {
        return false;
      }
      return true;
    },
    makeToastSuccess(message) {
      this.$bvToast.toast(message, {
        title: `Thông báo`,
        variant: 'success',
        solid: true,
      });
    },
    makeToastFaile(message) {
      this.$bvToast.toast(message, {
        title: `Thông báo`,
        variant: 'danger',
        solid: true,
      });
    },
    debounceInput: decounce(function () {
      this.searchEmployee();
    }, TIME_TRIGGER),
    onSelected(option) {
      this.selected = option.item.id;
      this.searchStock = option.item.name;
    },
    fetchStore: async function () {
      this.options[0].data = [];
      ApiService.get('v1/stores/all').then((response) => {
        const stores = response.data.data;
        stores.map((element) => {
          const store = {
            id: element.id,
            name: element.name,
            shortName: element.shortName,
            suggestionName: element.shortName + ' ( ' + element.name + ')',
          };
          this.options[0].data.push(store);
        });
        this.filteredOptions = [{ data: this.options[0].data }];
      });
    },
    filterStores() {
      if (!this.searchStock || this.searchStock.trim() === '') {
        this.filteredOptions = [{ data: this.options[0].data }];
        return;
      }
      const searchTerm = this.searchStock.toLowerCase().trim();
      const filtered = this.options[0].data.filter((store) => {
        return (
          store.name.toLowerCase().includes(searchTerm) ||
          store.shortName.toLowerCase().includes(searchTerm) ||
          store.suggestionName.toLowerCase().includes(searchTerm)
        );
      });
      this.filteredOptions = [{ data: filtered }];
    },
    formatMoney(number) {
      if (!number) return 0;
      return new Intl.NumberFormat('vn-VN').format(number);
    },
    getLinkDoc(item) {
      return `#/employees/upsert-employee?id=${item.id}`;
    },
  },
  computed: {
    ...mapGetters([
      'breadcrumbs',
      'pageTitle',
      'layoutConfig',
      'listPermission',
    ]),
    loaderEnabled() {
      return !/false/.test(this.layoutConfig('loader.type'));
    },
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig('loader.logo');
    },
  },
};
</script>

<style scoped>
.btn.btn-icon.btn-sm,
.btn-group-sm > .btn.btn-icon {
  height: calc(1.35em + 1.1rem + 2px);
  width: auto;
}

.icon:hover {
  background-color: #90c6fc;
}

.sttClass {
  width: 20px;
}

.productCode:hover {
  text-decoration: underline;
}
</style>
<style>
.autosuggest__results ul {
  list-style: none;
  cursor: pointer;
  margin-bottom: 0;
}

.autosuggest__results {
  position: absolute;
  background-color: #fff;
  z-index: 1;
  width: 100%;
  border: 1px solid #e0e0e0;
  overflow: scroll;
  max-height: 200px;
  position: absolute;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
}

#autosuggest__input {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #e5eaee;
  border-radius: 0.25rem;
  transition:
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  height: calc(1.35em + 1.1rem + 2px);
  padding: 0.55rem 0.75rem;
  font-size: 0.925rem;
  line-height: 1.35;
  border-radius: 0.28rem;
}

#autosuggest__input:focus {
  outline: none !important;
  border: 1px solid #92c5f9;
}

.autosuggest__results-item:hover {
  background-color: #ddd;
}

.autosuggest__results ul li {
  padding: 8px;
}

.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  border-top: 1px solid #ecf0f3;
}
.table.b-table.table-sm > thead > tr > [aria-sort]:not(.b-table-sort-icon-left),
.table.b-table.table-sm
  > tfoot
  > tr
  > [aria-sort]:not(.b-table-sort-icon-left) {
  background-position: right calc(1.5rem / 2) center;
  padding-right: calc(0.3rem + 0.65em);
}
</style>
